import { render, staticRenderFns } from "./menu1.vue?vue&type=template&id=3625636e&scoped=true"
import script from "./menu1.vue?vue&type=script&lang=js"
export * from "./menu1.vue?vue&type=script&lang=js"
import style0 from "./menu1.vue?vue&type=style&index=0&id=3625636e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625636e",
  null
  
)

export default component.exports